import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AudioCallStatuses } from 'constants/voip';

import { ICallState } from './types';

const initialState: ICallState = {
  audioCallStatus: undefined
};

const callsSlice = createSlice({
  name: 'call',
  initialState,
  reducers: {
    setAudioCallStatus: (
      state,
      action: PayloadAction<AudioCallStatuses | undefined>
    ) => {
      state.audioCallStatus = action.payload;
    }
  }
});

export const { setAudioCallStatus } = callsSlice.actions;
export default callsSlice.reducer;
